import reducer from './reducers'
import * as serviceSelectors from './selectors'
export type ServicesState = ReturnType<typeof reducer>
export default reducer
export { serviceSelectors }
